module.exports = __webpack_public_path__ + "img/f046576.png";